import { render, staticRenderFns } from "./Juza.vue?vue&type=template&id=0656d016&"
import script from "./Juza.vue?vue&type=script&lang=js&"
export * from "./Juza.vue?vue&type=script&lang=js&"
import style0 from "./Juza.vue?vue&type=style&index=0&id=0656d016&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports